import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type SaveAppraisalMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  condition: Types.Scalars['String']['input'];
  trimOverrides?: Types.InputMaybe<Types.Scalars['jsonb']['input']>;
  mileageOverride?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
  valueType: Types.Scalars['String']['input'];
  valueAdjustment: Types.Scalars['bigint']['input'];
  valueTotal: Types.Scalars['bigint']['input'];
  vehicleNotes?: Types.InputMaybe<Types.Scalars['String']['input']>;
  appraiserName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  appraiserCredit?: Types.InputMaybe<Types.Scalars['String']['input']>;
  appraiserContact?: Types.InputMaybe<Types.Scalars['String']['input']>;
  appraiserNotes?: Types.InputMaybe<Types.Scalars['String']['input']>;
  appraiserTime?: Types.InputMaybe<Types.Scalars['timestamptz']['input']>;
}>;


export type SaveAppraisalMutation = { __typename?: 'mutation_root', update_appraisals?: { __typename?: 'appraisals_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'appraisals', id: number }> } | null };


export const SaveAppraisalDocument = gql`
    mutation saveAppraisal($id: bigint!, $condition: String!, $trimOverrides: jsonb, $mileageOverride: bigint, $valueType: String!, $valueAdjustment: bigint!, $valueTotal: bigint!, $vehicleNotes: String, $appraiserName: String, $appraiserCredit: String, $appraiserContact: String, $appraiserNotes: String, $appraiserTime: timestamptz) {
  update_appraisals(
    where: {id: {_eq: $id}}
    _set: {condition: $condition, trim_overrides: $trimOverrides, mileage_override: $mileageOverride, value_type: $valueType, value_adjustment: $valueAdjustment, value_total: $valueTotal, vehicle_notes: $vehicleNotes, appraiser_name: $appraiserName, appraiser_credentials: $appraiserCredit, appraiser_contact: $appraiserContact, appraiser_notes: $appraiserNotes, appraiser_expire_time_utc: $appraiserTime, last_save_time_utc: "now()"}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type SaveAppraisalMutationFn = Apollo.MutationFunction<SaveAppraisalMutation, SaveAppraisalMutationVariables>;

/**
 * __useSaveAppraisalMutation__
 *
 * To run a mutation, you first call `useSaveAppraisalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAppraisalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAppraisalMutation, { data, loading, error }] = useSaveAppraisalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      condition: // value for 'condition'
 *      trimOverrides: // value for 'trimOverrides'
 *      mileageOverride: // value for 'mileageOverride'
 *      valueType: // value for 'valueType'
 *      valueAdjustment: // value for 'valueAdjustment'
 *      valueTotal: // value for 'valueTotal'
 *      vehicleNotes: // value for 'vehicleNotes'
 *      appraiserName: // value for 'appraiserName'
 *      appraiserCredit: // value for 'appraiserCredit'
 *      appraiserContact: // value for 'appraiserContact'
 *      appraiserNotes: // value for 'appraiserNotes'
 *      appraiserTime: // value for 'appraiserTime'
 *   },
 * });
 */
export function useSaveAppraisalMutation(baseOptions?: Apollo.MutationHookOptions<SaveAppraisalMutation, SaveAppraisalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAppraisalMutation, SaveAppraisalMutationVariables>(SaveAppraisalDocument, options);
      }
export type SaveAppraisalMutationHookResult = ReturnType<typeof useSaveAppraisalMutation>;
export type SaveAppraisalMutationResult = Apollo.MutationResult<SaveAppraisalMutation>;
export type SaveAppraisalMutationOptions = Apollo.BaseMutationOptions<SaveAppraisalMutation, SaveAppraisalMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appraisals/queries/saveAppraisal.mutation.gql}
 */
export async function saveAppraisal(
  variables: SaveAppraisalMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<SaveAppraisalMutation['update_appraisals']>
export async function saveAppraisal(
  variables: SaveAppraisalMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<SaveAppraisalMutation>
export async function saveAppraisal(
  variables: SaveAppraisalMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<SaveAppraisalMutation['update_appraisals'] | SaveAppraisalMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<SaveAppraisalMutation>(
    SaveAppraisalDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_appraisals
}